import { render, staticRenderFns } from "./releaseAdmin.vue?vue&type=template&id=48cb40e9"
import script from "./releaseAdmin.vue?vue&type=script&lang=js"
export * from "./releaseAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports